export const es = {
  brand: "Ads Library Downloader",
  nav: {
    dashboard: "Biblioteca",
    history: "Historial",
    export: "Exportar",
    settings: "Ajustes",
    extension: "Extensión",
    logout: "Salir",
  },
  library: {
    tagline: "Todos tus anuncios, en un solo lugar",
    search: "Buscar anuncios, marcas, textos…",
    activeAds: "Anuncios activos",
    platforms: "Plataformas",
    brands: "Marcas",
    asset: "Media",
    sort: "Ordenar",
    display: "Vista",
    tags: "Etiquetas",
    days: "días",
    day: "día",
    active: "Activo",
    savedAgo: "Guardado hace {n} {unit}",
    empty: "Tu biblioteca está vacía. Instala la extensión y pulsa SAVE en cualquier anuncio de Meta Ad Library.",
    adLibrary: "Ad Library",
    landing: "Landing page",
    boards: "BOARDS",
  },
  auth: {
    signInTitle: "Iniciar sesión",
    signInSubtitle: "Accede a tu panel de descargas de la Biblioteca de Anuncios de Meta.",
    signUpTitle: "Crear cuenta",
    signUpSubtitle: "Empieza a organizar tus creativos en minutos.",
    email: "Correo",
    password: "Contraseña",
    name: "Nombre",
    signIn: "Entrar",
    signUp: "Crear cuenta",
    noAccount: "¿Sin cuenta?",
    hasAccount: "¿Ya tienes cuenta?",
    createOne: "Crear una",
    signInNow: "Entrar",
    forgot: "Olvidé mi contraseña",
    welcomeBack: "¡Bienvenido de nuevo!",
    accountCreated: "¡Cuenta creada!",
  },
  stats: {
    totalDownloads: "Descargas totales",
    images: "Imágenes",
    videos: "Videos",
    monitoredAds: "Anuncios monitoreados",
    advertisers: "Anunciantes",
    countries: "Países",
  },
  history: {
    title: "Historial de descargas",
    subtitle: "Filtra, busca y vuelve a descargar cualquier creativo.",
    search: "Buscar anunciante, titular, archivo…",
    advertiser: "Anunciante",
    country: "País",
    type: "Tipo",
    date: "Fecha",
    file: "Archivo",
    actions: "Acciones",
    all: "Todos",
    image: "Imagen",
    video: "Video",
    redownload: "Re-descargar",
    empty: "Aún no hay descargas. Instala la extensión para comenzar.",
    filters: "Filtros",
  },
  export: {
    title: "Exportar",
    subtitle: "Descarga tu historial y creativos en CSV, JSON o ZIP.",
    csv: "Descargar CSV",
    json: "Descargar JSON",
    zip: "Descargar ZIP (metadatos + medios)",
    zipHint: "El ZIP incluye metadata.json y archivos en Marca/Campaña/[imagens|videos].",
  },
  settings: {
    title: "Ajustes",
    subtitle: "Preferencias compartidas entre la extensión y el panel.",
    defaultFolder: "Carpeta por defecto",
    parallelLimit: "Descargas en paralelo",
    namingTemplate: "Plantilla de nombre",
    autoRetry: "Reintento automático",
    maxRetries: "Máx. reintentos",
    language: "Idioma",
    theme: "Tema",
    themeLight: "Claro",
    themeDark: "Oscuro",
    save: "Guardar",
    saved: "Ajustes guardados.",
  },
  extension: {
    title: "Extensión de Chrome",
    subtitle: "Instala la extensión y conéctala a tu panel en 3 pasos.",
    step1: "Descarga el paquete (.zip) y extráelo localmente.",
    step2: "Abre chrome://extensions, activa el Modo desarrollador y pulsa Cargar descomprimida.",
    step3: "En el popup, pega la URL de la API y el token abajo y activa Sincronizar historial.",
    download: "Descargar extensión (.zip)",
    apiUrl: "URL de la API",
    token: "Token de acceso",
    copy: "Copiar",
    copied: "¡Copiado!",
    version: "Versión",
  },
  common: {
    loading: "Cargando…",
    filter: "Filtrar",
    clear: "Limpiar",
    all: "Todos",
    close: "Cerrar",
  },
};
